import type { ExerciseSection } from "@/lib/api/api-client";

export interface SectionListProps {
  sections: ExerciseSection[];
}

/** Tabular list of sections, title left, no completion state, no progression. */
export function SectionList({ sections }: SectionListProps) {
  return (
    <div>
      <h2 className="mb-3 text-[11px] font-semibold uppercase tracking-[0.15em] text-text-muted">
        Sections
      </h2>

      <ul className="flex flex-col gap-1">
        {sections.map((section, i) => (
          <li
            key={i}
            className="flex items-center gap-3 py-1.5 text-sm text-text-secondary"
          >
            <span className="text-text-muted/40">·</span>
            <span className="flex-1">{section.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
